import { Check, Close } from "@mui/icons-material"
import { Card, IconButton } from "@mui/material"
import { MdCheck, MdClose, MdContentCopy, MdLocationOn, MdTouchApp, MdUndo } from 'react-icons/md'
import styled from "styled-components"
import { copy } from "../../servicos/Uteis"

const Div = styled.div`
    width: 100%;
    margin-top: 1rem;
    &:disabled {
        color: red !important;
    }
`
const ColunaIndex = styled.div`
    position: relative;
    width     : 15%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Centralizado = styled.div`
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ColunaEndereco = styled.div`
    display       : flex;
    flex-direction: column;
    align-items   : center;
    width         : 70%;
    text-transform: uppercase;
    line-height   : 1;
    margin        : 0;
    padding       : 0;
    font-size     : 0.8rem;
    font-weight   : bold;
`

const MarcadorPonto = styled.div`
    position        : relative;
    display         : flex;
    font-weight     : 800;
    font-size       : 0.8rem;
    align-items     : center;
    justify-content : center;
    background-color: white;
    color: ${props => (props.disabled ? '#888' : 'var(--primaria)')};
    border          : 2px solid ${props => (props.disabled ? '#888' : 'var(--primaria)')};
    border-radius   : 50%;
    height          : 1.6rem;
    width           : 1.6rem;
`
export default function CardEndereco(props) {
    
    return <Div disabled={props.disabled}>
        <Card
            onClick={props.disabled ? () => { } : props.onClick}
            style={{
                maxHeight: '90vh',
                overflow: 'auto',
                color: props.cor ?? "auto",
                ...(!!!props.retorno && {
                    backgroundColor: 'rgba(181, 209, 238, 0.45)'
                })
            }}
            className={
                (props.className ?? "py-2 relative") + (
                    props.disabled
                        ? ' text-disabled'
                        : ''
                ) + (
                    props.retorno
                        ? props.disabled
                            ? ' bgPriBrighter text-white'
                            : ' bgPri text-white'
                        : ' fundoEnderecosDetalhes'
                )
            }
        >
            <div className="flex w-full" style={{
                paddingBottom: props.recebimento ? '1rem' : '0',
            }}>
                <ColunaIndex>
                    <Centralizado>
                        <MarcadorPonto disabled={props.disabled}>
                            {props.id}
                            {props.confirmaEntrega && <div
                                className={(props.confirmaEntrega == "S"
                                    ? "!bg-green-500"
                                    : "!bg-red-500") + " !text-white small"}
                                style={{
                                    width: "1.5rem",
                                    textAlign: "center",
                                    borderRadius: "50%",
                                    height: "1.5rem",
                                    position: "absolute",
                                    top: "0",
                                    opacity: 0.3
                                }}
                            >
                                {props.confirmaEntrega == "S"
                                    ? <>
                                        <Check />
                                    </>
                                    : <>
                                        <Close />
                                    </>}
                            </div>}
                        </MarcadorPonto>

                    </Centralizado>
                </ColunaIndex>
                <ColunaEndereco>
                    {props.retorno && <div className="small text-white">
                        <MdUndo size="22" /> Retorno
                    </div>}
                    <div className={`  ${props.retorno ? 'text-white' : ''}`}>
                        {props.endereco}{props.complemento != '' && <span> - {props.complemento}</span>}
                    </div>
                </ColunaEndereco>
                <ColunaIndex>


                    {props.icone
                        ? <MdLocationOn className={props.retorno ? 'text-white' : ''} size={24} />
                        : <MdTouchApp className={props.retorno ? 'text-white' : ''} size={24} />
                    }
                </ColunaIndex>
            </div>

            {props.observacao && (
                <div
                    className={`w-full text-center text-sm opacity-75 ${props.recebimento ? 'pb-3' : ''
                        }`}
                >
                    <div className="font-400">Observação</div>
                    <div className="flex items-center justify-center gap-2">
                        <div id={`observacao-${props.id}`} className="px-3 leading-none whitespace-pre-line">{props.observacao}</div>
                        <IconButton color="primary" onClick={() => copy(document.querySelector(`#observacao-${props.id}`).textContent)}>
                            <MdContentCopy />
                        </IconButton>
                    </div>
                </div>
            )}

            {props.recebimento && props.valor != '' && (
                <div
                    className={`w-full text-center text-black py-1 text-sm ${props.trocarPonto ? '' : 'mb-[-0.5rem]'
                        }`}
                    style={{ backgroundColor: 'oklch(0.72 0.14 79.37)' }}
                >
                    Receber neste ponto{' '}
                    {isNaN(props.valor)
                        ? ''
                        : new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        }).format(props.valor)}
                </div>
            )}

            {props.trocarPonto && (
                <div className="bg-zinc-800 text-white w-full py-2 text-sm mt-2 mb-[-0.5rem] pl-[4.3rem] font-normal">
                    Trocar próximo ponto
                </div>
            )}

        </Card>
    </Div>
} 